import { useIntl } from 'react-intl';
import { Col, Input, Row, Select } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import {
  ListPlanAccountsQuery,
  PlanAccountDestination,
  PlanAccountHierarchy,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';

function PlanAccountsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListPlanAccountsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} lg={8}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, description: value }))
          }
          placeholder={intl.formatMessage({
            id: 'planAccounts.filters.description',
          })}
        />
      </Col>

      <Col span={24} md={6} lg={4}>
        <Select
          allowClear
          style={{ width: '100%' }}
          value={queryParams?.hierarchy}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, hierarchy: value }))
          }
          placeholder={intl.formatMessage({
            id: 'planAccounts.filters.hierarchy',
          })}
          options={[
            {
              value: PlanAccountHierarchy.Syntetics,
              label: intl.formatMessage({
                id: 'planAccounts.modal.general.form.hierarchy.syntetics',
              }),
            },
            {
              value: PlanAccountHierarchy.Analitical,
              label: intl.formatMessage({
                id: 'planAccounts.modal.general.form.hierarchy.analitical',
              }),
            },
          ]}
        />
      </Col>

      <Col span={24} md={6} lg={4}>
        <Select
          allowClear
          style={{ width: '100%' }}
          value={queryParams?.destination}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, destination: value }))
          }
          placeholder={intl.formatMessage({
            id: 'planAccounts.filters.destination',
          })}
          options={[
            {
              value: PlanAccountDestination.Revenue,
              label: intl.formatMessage({
                id: 'planAccounts.modal.general.form.destination.revenue',
              }),
            },
            {
              value: PlanAccountDestination.Expense,
              label: intl.formatMessage({
                id: 'planAccounts.modal.general.form.destination.expense',
              }),
            },
          ]}
        />
      </Col>

      <Col span={24} md={6} lg={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default PlanAccountsExtraFilters;
